import { Trans } from "@lingui/react/macro";
import type { ErrorComponentProps } from "@tanstack/react-router";
import {
	ErrorComponent,
	Link,
	rootRouteId,
	useMatch,
	useRouter,
} from "@tanstack/react-router";
import { Button } from "~/components/ui/button";
import { SessionExpiredForm } from "~/components/views/auth/session-expired-form";
import { isTRPCClientError } from "~/trpc/client";

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
	const router = useRouter();
	const isRoot = useMatch({
		strict: false,
		select: (state) => state.id === rootRouteId,
	});

	if (isTRPCClientError(error)) {
		if (error.data?.code === "UNAUTHORIZED") {
			return (
				<div className="min-h-svh min-w-0 flex-1 p-4 flex flex-col items-center justify-center gap-6">
					<div className="relative flex w-full max-w-md flex-col justify-center-center gap-6 mx-auto">
						<SessionExpiredForm />
					</div>
				</div>
			);
		}
	}

	return (
		<div className="min-w-0 flex-1 p-4 flex flex-col items-center justify-center gap-6">
			<ErrorComponent error={error} />
			<div className="flex gap-2 items-center flex-wrap">
				<Button
					onClick={() => {
						router.invalidate();
					}}
					type="button"
				>
					<Trans>Try Again</Trans>
				</Button>
				{isRoot ? (
					<Button asChild>
						<Link to="/">
							<Trans>Home</Trans>
						</Link>
					</Button>
				) : (
					<Button asChild>
						<Link
							onClick={(e) => {
								e.preventDefault();
								window.history.back();
							}}
							to="/"
						>
							<Trans>Go Back</Trans>
						</Link>
					</Button>
				)}
			</div>
		</div>
	);
}
